import React from "react";

export default function divider(){
    return(
        <div className='divider' />
    )
}